import { getCookie } from "./cookieUtils";
import { useState, useEffect, useRef } from "react";
import LoginBox from "./LoginBox";
import TrackingBox from "./TrackingBox";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Pagination } from 'antd';
import * as XLSX from "xlsx";


const PickupStatusReport = () => {
    const inputrefs = useRef([]);
    const [loginToken, setLoginToken] = useState(getCookie("loginToken") || null);
    const [userName, setUserName] = useState(getCookie("userName") || "");
    const [accessType, setAccessType] = useState(getCookie("accessType") || "");
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);


    const getDateDaysAgo = (days) => {
        const date = new Date();
        date.setDate(date.getDate() - days);
        return date.toISOString().split('T')[0];
    };

    const getTodayDate = () => {
        return new Date().toISOString().split('T')[0];
    };

    const [formData, setFormData] = useState({
        fromDate: getDateDaysAgo(7),
        toDate: getTodayDate(),
        packetStatus: "",
        awbNo: "",
    });

    // Set initial focus
    useEffect(() => {
        if (inputrefs.current["txtFromDate"]) {
            inputrefs.current["txtFromDate"].focus();
        }
    }, []);

    const hasSearched = useRef(false);

    // Fetch data when page/pageSize changes (only after first manual search)
    useEffect(() => {
        if (loginToken && hasSearched.current) {
            fetchUsers();
        }
    }, [currentPage, pageSize]);

    // Show/Fetch all users
    const fetchUsers = async () => {
        hasSearched.current = true;
        setLoading(true);
        try {

            const payload = {
                AuthToken: "NASSKD28462RWKF35793FWEU757",
                LoginUserCode: userName,
                LoginToken: loginToken,
                PageIndex: String(currentPage),
                PageSize: String(pageSize),
                Search: search,
                ...formData,
                accessType: accessType,
                Type: "S"
            };

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Report/ShowPacketStatusReport`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const resData = await response.json();
            
            if (resData.Status === "ERROR" || resData.status === "ERROR") {
                toast.error(resData.Message || resData.message || "No Record Found");
                setUsers([]);
                setTotalRecords(0);
            } else {
                const successMsg = resData.Message || resData.message;
                if (successMsg && successMsg.trim() !== "") {
                    toast.success(successMsg);
                }
                setUsers(resData.Data || []);
                setTotalRecords(Number(resData.TotalRecord) || 0);
            }
            //setPageSize(Number(resData.PageSize) || 10);

        } catch (error) {
            console.error("Error fetching users:", error);
            toast.error("Failed to fetch users.");
        } finally {
            setLoading(false);
        }
    };


    const handleExport = async () => {
        try {
            const payload = {
                AuthToken: "NASSKD28462RWKF35793FWEU757",
                LoginUserCode: userName,
                LoginToken: loginToken,
                PageIndex: String(currentPage),
                PageSize: String(pageSize),
                Search: search,
                ...formData,
                accessType: accessType,
                Type: "E"
            };

            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/api/Report/ShowPacketStatusReport`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                }
            );

            const resData = await response.json();
            const allData = resData.Data || [];

            if (allData.length === 0) {
                toast.error(resData?.Message);
                return;
            }

            const worksheet = XLSX.utils.json_to_sheet(allData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "PacketStatusReport");

            XLSX.writeFile(workbook, "PacketStatusReport.xlsx");

        } catch (error) {
            console.error(error);
            toast.error("Export failed");
        }
    };

    const handleLoginSuccess = (loginData) => {
        setLoginToken(loginData.loginToken);
        setUserName(loginData.userName);
        setAccessType(loginData.accessType);
        fetchUsers();
    };

    // Reset form
    const resetForm = () => {
        setFormData({
            fromDate: getDateDaysAgo(7),
            toDate: getTodayDate(),
            packetStatus: "",
            awbNo: "",
        });
        setUsers([]);
        setTotalRecords(0);
        setCurrentPage(1);
        setSearch("");
        setTimeout(() => {
            if (inputrefs.current["txtFromDate"]) inputrefs.current["txtFromDate"].focus();
        }, 0);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    return (
        <>
<section>
                <div className="container-fluid">
                    <img src="images/innerbanner.webp" className='img-fluid' alt="" />
                </div>
            </section>

            {/* MAIN SECTION */}
            <section className="main-section">
                <div className="container">
                    <div className="row g-4">

                        {/* SIDEBAR */}
                        <div className="col-lg-3">
                            <TrackingBox />
                            <LoginBox onLoginSuccess={handleLoginSuccess} />

                            {/* Contact */}
                            <div className="contact-card">
                                <div className="contact-title">Contact</div>
                                <div className="contact-item">
                                    <div className="contact-icon phone">
                                        <i className="fa fa-phone"></i>
                                    </div>
                                    <a href="tel:01141606842">+91 96672 33072</a>
                                </div>
                                <div className="contact-item">
                                    <div className="contact-icon email">
                                        <i className="fa fa-envelope"></i>
                                    </div>
                                    <a href="#">oxford_express@yahoo.co.in</a>
                                </div>
                                <div className="contact-item">
                                    <div className="contact-icon email">
                                        <i className="fa fa-envelope"></i>
                                    </div>
                                    <a href="#">info@oxfordexp.com</a>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-9">
                            <h4 className="mb-3">Packet Status Report</h4>
                            <div className="row mb-3 g-2">

                                {/* From Date */}
                                <div className="col-md-4">
                                    <div className="login-field mb-0">
                                    <label>From Date</label>
                                    <input
                                        id="txtFromDate"
                                        type="date"
                                        ref={(el) => (inputrefs.current["txtFromDate"] = el)}
                                        className="track-input"
                                        value={formData.fromDate}
                                        onChange={(e) =>
                                            setFormData({ ...formData, fromDate: e.target.value })
                                        }
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                inputrefs.current["txtToDate"]?.focus();
                                            }
                                        }}
                                    />
                                </div>
                                </div>

                                {/* To Date */}
                                <div className="col-md-4">
                                    <div className="login-field mb-0">
                                    <label>To Date</label>
                                    <input
                                        id="txtToDate"
                                        type="date"
                                        ref={(el) => (inputrefs.current["txtToDate"] = el)}
                                        className="track-input"
                                        value={formData.toDate}
                                        onChange={(e) =>
                                            setFormData({ ...formData, toDate: e.target.value })
                                        }
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") inputrefs.current["txtUserType"].focus();
                                        }}
                                    />
                                </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="login-field mb-0">
                                        <label>Packet Status<span className="text-danger">*</span></label>
                                        <select
                                            id="txtUserType"
                                            name="packetStatus"
                                            className="track-input"
                                            ref={(el) => (inputrefs.current["txtUserType"] = el)}
                                            value={formData.packetStatus}
                                            onChange={handleInputChange}
                                            required
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") inputrefs.current["txtAWBNo"].focus();
                                            }}
                                        >
                                            <option value="">--Select Packet Status--</option>
                                            <option value="Delivered">Delivered</option>
                                            <option value="RTO">RTO</option>
                                            <option value="In-Transit">In-Transit</option>
                                            <option value="All">All</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                <div className="login-field mb-0">
                                    <label>AWB No</label>
                                    <input
                                        id="txtAWBNo"
                                        ref={(el) => (inputrefs.current["txtAWBNo"] = el)}
                                        type="text"
                                        name="awbNo"
                                        className="track-input"
                                        placeholder="Enter AWB No"
                                        value={formData.awbNo}
                                        onChange={handleInputChange}
                                        required
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                inputrefs.current["btnSub"]?.focus();
                                            }
                                        }}
                                    />
                                </div>
                                </div>

                            </div>

                            <div className="d-flex gap-3 mt-3 w-50">
                                <button id="btnSub" type="submit" className="track-btn" disabled={loading} onClick={fetchUsers} ref={(el) => (inputrefs.current["btnSub"] = el)}>
                                    <i className="fa fa-search me-1"></i>
                                    Search
                                </button>
                                <button type="button" className="login-btn" onClick={resetForm}>
                                    <i className="fa fa-undo me-1"></i> Reset
                                </button>
                                <button type="button" className="export-btn" onClick={handleExport}>
                                    <i className="fa fa-download me-1"></i> Export
                                </button>
                            </div>

                            {/* Users Grid */}
                            <div className="mt-5">
                                <div className="d-flex justify-content-end mb-3">
                                    {/*<div className="d-flex gap-2 w-50">*/}
                                    {/*    <input*/}
                                    {/*        type="text"*/}
                                    {/*        className="track-input w-50 m-0"*/}
                                    {/*        placeholder="Search user..."*/}
                                    {/*        value={search}*/}
                                    {/*        onChange={(e) => setSearch(e.target.value)}*/}
                                    {/*        onKeyDown={(e) => {*/}
                                    {/*            if (e.key === "Enter") fetchUsers();*/}
                                    {/*        }}*/}
                                    {/*    />*/}
                                    {/*    <button */}
                                    {/*        type="button" */}
                                    {/*        className="track-btn m-0" */}
                                    {/*        onClick={fetchUsers} */}
                                    {/*        disabled={loading}*/}
                                    {/*        style={{ height: "44px", width: "55px" }}*/}
                                    {/*    >*/}
                                    {/*        <i className="fa fa-search me-1"></i>*/}
                                    {/*    </button>*/}
                                    {/*</div>*/}

                                    <select
                                        className="form-select w-auto"
                                        value={pageSize}
                                        onChange={(e) => {
                                            setPageSize(Number(e.target.value));
                                            setCurrentPage(1);
                                        }}
                                    >
                                        <option value={10}>10</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                </div>

                                {/* Table */}
                                <div className="table-responsive overflow-x-hidden" style={{ maxHeight:"500px" }}>
                                    {loading ? (
                                        <div className="text-center">
                                            <div className="spinner-border text-primary"></div>
                                        </div>
                                    ) : (
                                            <table className="table table-bordered table-hover" style={{ whiteSpace: "nowrap" }} >
                                            <thead className="table-dark">
                                                <tr>
                                                    <th>SrNo.</th>
                                                    <th>AWB No.</th>
                                                    <th>Customer Name</th>
                                                    <th>Booking Date</th>
                                                    <th>Consignee</th>
                                                    <th>Booking Mode</th>
                                                    <th>Packages</th>
                                                    <th>Weight (kg)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {users.length > 0 ? (
                                                    users.map((record, index) => (
                                                        <tr key={index}>
                                                            <td>{record.SrNo}</td>
                                                            <td>{record.AwbNo}</td>
                                                            <td>{record.Cname}</td>
                                                            <td>{record.BookingDate}</td>
                                                            <td>{record.Consignee || '-'}</td>
                                                            <td>
                                                                {/*<span className={`badge ${record.BookingMode === 'AR' ? 'bg-success' : 'bg-primary'}`}>*/}
                                                                {/*    {record.BookingMode === 'AR' ? 'AR (Air)' : 'SF (Surface)'}*/}
                                                                {/*</span>*/}
                                                                {record.BookingMode}
                                                            </td>
                                                            <td>{record.Packages}</td>
                                                            <td>{record.Weight}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="8" className="text-center">
                                                            No records found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    )}
                                </div>

                                {!loading && users.length > 0 && totalRecords > pageSize && (
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div className="text-muted">
                                            Showing {users.length} of {totalRecords} records
                                        </div>

                                        <Pagination
                                            current={currentPage}
                                            total={totalRecords}
                                            pageSize={pageSize}
                                            onChange={(page) => setCurrentPage(page)}
                                            showSizeChanger={false}
                                            size="default"
                                            showQuickJumper={false}
                                        />
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* STATS STRIP */}
            <section className="stats-strip">
                <div className="container">
                    <div className="row g-0 text-center">
                        <div className="col-6 col-md-3 stat-item py-2">
                            <div className="stat-number">4.5L+</div>
                            <div className="stat-label">Packets / Month</div>
                        </div>
                        <div className="col-6 col-md-3 stat-item py-2">
                            <div className="stat-number">1000+</div>
                            <div className="stat-label">Cities Covered</div>
                        </div>
                        <div className="col-6 col-md-3 stat-item py-2">
                            <div className="stat-number">35+</div>
                            <div className="stat-label">Years Experience</div>
                        </div>
                        <div className="col-6 col-md-3 stat-item py-2">
                            <div className="stat-number">10K+</div>
                            <div className="stat-label">Happy Clients</div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default PickupStatusReport;

